export default __webpack_public_path__ + "static/wClause1-f0794a1000847e49b9c8eed611c1c448.gif";